<template>

  <div class="quiz__step is-active" id="step-1">

    <div class="quiz__tabs">

      <label class="quiz__tab" v-for="material in materials" :key="material.id" :class="materialMain == material.value ? 'active' : ''">
        {{ material.name }}
        <input type="radio" class="d-none" v-model="materialMain" :value="material.value" />
      </label>

    </div>

    <div class="quiz__tab-content">


      <div class="quiz__tab-item" v-for="material in materials" :key="material.id+'q'">
        <div class="quiz__tab-item-wrap" v-show="materialMain == material.value">
          <div class="quiz__aside">
            <div class="quiz-checks">

              <div v-for="variant in getVariants(material.variants, 'one')" :key="variant.id+'l'">
                <label class="radio param-switch param-{{ variant.id }} " :class="variant.value == voltage ? 'checked' : ''">
                  <input type="radio" v-model="voltage" :value="variant.value">
                  <div class="radio__text">{{ variant.name }}</div>
                </label>
              </div>

            </div>
          </div>
          <div class="quiz__content">
            <div v-for="variant in getVariants(material.variants, 'one')" :key="variant.id+'q'">
              <div class="quiz__product param-block param-block-{{ variant.id }}" v-show="voltage == variant.value">

                <div v-if="variant.photo" class="quiz__product-image">
                  <img :src="loadFile(variant.photo)" style="width: 100%;" alt="">
                </div>


                <div v-if="variant.description" v-html="variant.description" class="quiz__product-info">

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: "materialParamComponent",
  props: ['step', 'materials', 'materialParam', 'stepOne'],

  data() {
    return {
      fileTypes: {
        jpg: {
          type: 'img',
          name: 'jpg',
          mime: 'image/jpeg'
        },
        jpeg: {
          type: 'img',
          name: 'jpeg',
          mime: 'image/jpeg'
        },
        png: {
          type: 'img',
          name: 'png',
          mime: 'image/png'
        },
        gif: {
          type: 'img',
          name: 'gif',
          mime: 'image/gif'
        },
        doc: {
          type: 'bin',
          name: 'doc',
          icon: 'word',
          mime: 'application/msword'
        },
        docx: {
          type: 'bin',
          name: 'docx',
          icon: 'word',
          mime: 'application/msword'
        },
        xls: {
          type: 'bin',
          name: 'xls',
          icon: 'excel',
          mime: 'application/vnd.ms-excel'
        },
        xlsx: {
          type: 'bin',
          name: 'xlsx',
          icon: 'excel',
          mime: 'application/vnd.ms-excel'
        },
        pdf: {
          type: 'bin',
          name: 'pdf',
          icon: 'pdf',
          mime: 'application/pdf'
        },
        some: {
          type: 'bin',
          name: 'some',
          icon: 'some',
          mime: 'application/binary'
        }
      },
    }
  },

  computed:{
      materialMain:{
          get(){
              return this.materialParam;
          },
          set(newVal){
              this.$emit('changeMaterialParam', newVal)
          }
      },
      voltage:{
          get(){
              return this.stepOne;
          },
          set(newVal){
              this.$emit('changeVoltage', newVal)
          }
      }
  },

  methods: {
    getVariants(variants, name){
      return (variants.filter(element => element.step == name));
    },

    getFileType: function (fileName) {
      let extension;
      extension = fileName.split('.').pop();
      extension = extension.toLowerCase();
      if (this.fileTypes[extension]) {
        return this.fileTypes[extension];
      }
      return null;
    },

    loadFile(file){
      let fileType = this.getFileType(file.name);

      return '/vpanel/files/main/thumbnail' + (fileType ? '.' + fileType.name : '') + '/?' +
          'name=' + file.name ;
    },
  }
}
</script>

<style scoped>

</style>